import React from "react";

const CheckboxGroup = ({ options, selectedOptions, setSelectedOptions }) => {
  const handleOptionChange = (option) => {
    const updatedSelectedOptions = selectedOptions.includes(option)
      ? selectedOptions.filter((selected) => selected !== option)
      : [...selectedOptions, option];

    setSelectedOptions(updatedSelectedOptions);
  };

  return (
    <>
      {options.map((option) => (
        <label key={option} className="cursor-pointer basis-[31%] grow">
          <input
            type="checkbox"
            value={option}
            checked={selectedOptions.includes(option)}
            onChange={() => handleOptionChange(option)}
            className="hidden"
          />
          <span
            className={`flex items-center justify-center px-2 py-1 min-h-12 border-2 rounded-md transition-colors text-center text-xs break-words ${
              selectedOptions.includes(option)
                ? "border-electrum bg-electrum-100"
                : "bg-white border-gray hover:border-electrum"
            }`}
          >
            {option}
          </span>
        </label>
      ))}
    </>
  );
};

export default CheckboxGroup;
